import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const HotelSelectorDropdownEl = styled(Div)`
    &&& {
      min-width: 100%;
      width: auto;
    }
`;
